import { Avatar, Box } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Active, Deleted } from "routes/therapist/components";
import { styles } from "routes/therapist/components/PersonalInfo";
import { HFlex, Pane, Text } from "shared";
import { stripDeletedTagFromEmail } from "utils/misc";

interface AccountProps {
  user: any;
}

export const Account: React.FC<AccountProps> = ({ user }) => {
  const { t } = useTranslation();

  const details = [
    [t("form.first_name"), user.first_name],
    [t("form.last_name"), user.last_name],
    [t("form.email"), user.email && stripDeletedTagFromEmail(user.email)],
    [t("form.phone"), user.phone_number],
    [t("form.uid"), user.uid],
    [t("form.state_zip"), user.state_zip],
    [t("form.address"), user.address],
    [t("form.country"), user.country],
    [t("form.birth"), user.birthday],

    [t("settings.profile_information.time_zone"), user.time_zone],
  ];

  return (
    <div>
      <Text paragraph caption secondary>
        {t("patients.account")}
      </Text>
      <Pane>{user.deleted_at ? <Deleted user={user} /> : <Active user={user} />}</Pane>
      <Pane>
        <HFlex gap={2} alignItems="center" mb={2}>
          <Avatar src="" />
          <Box overflow="auto">
            <Text heading bold nowrap mb={0}>
              {user.first_name} {user.last_name}
            </Text>
            <Text paragraph nowrap mb={0}>
              {user?.hcp || user?.health_care_provider_name}
            </Text>
          </Box>
        </HFlex>

        <Pane dark className={styles.grid}>
          {details.map(([label, value]) => (
            <React.Fragment key={label}>
              <Text light nowrap>
                {label}
              </Text>
              <Text bold nowrap>
                {value}
              </Text>
            </React.Fragment>
          ))}
          {user.roles.length > 0 && (
            <>
              <Text light nowrap>
                {t("form.roles")}
              </Text>
              <Text bold nowrap>
                {user.roles.join(", ")}
              </Text>
            </>
          )}
        </Pane>
      </Pane>
    </div>
  );
};
